import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const RequireAuth = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div>Loading...</div>; // Or any other loading indicator
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default RequireAuth;
